import { Modal } from "antd";

const AddNewModal = ({ open, title, onClose, children }) => {
  return (
    <Modal open={open} footer={null} title={title} onCancel={onClose}>
      {children}
    </Modal>
  );
};

export default AddNewModal;
